import { Variants, motion } from 'framer-motion'
import { cn } from '../../utils/helper'

type Props = {
    className?: string
    onClick?: () => void
}

export default function Curve({ className, onClick }: Props) {
    const initialPath = `M100 0 L200 0 L200 ${window.innerHeight} L100 ${window.innerHeight} Q-100 ${window.innerHeight / 2} 100 0`
    const targetPath = `M100 0 L200 0 L200 ${window.innerHeight} L100 ${window.innerHeight} Q100 ${window.innerHeight / 2} 100 0`

    const pathAnimation: Variants = {
        initial: {
            d: initialPath
        },
        enter: {
            d: targetPath,
            transition: {
                duration: 1,
                ease: [0.65, 0, 0.35, 1]
            }
        },
        exit: {
            d: initialPath,
            transition: {
                duration: 1,
                ease: [0.65, 0, 0.35, 1]
            }
        }
    }

    return (
        <svg onClick={onClick} className={cn('absolute right-[69.9vw] top-0 h-full w-[100px] fill-black stroke-none', className)}>
            <motion.path variants={pathAnimation} initial="initial" animate="enter" exit="exit"></motion.path>
        </svg>
    )
}
